import {BaseService} from '../baseService.js';

/* 
 * Handles interaction with the api
 */
export class FuelTaxPrefService extends BaseService {

	constructor() {	
		super();
	}
	
	async getFuelTaxPref(unitGroupId) {
		var groupId = '';
		if (unitGroupId) {
			groupId = '?unitGroupId=' + unitGroupId;
		}
		var data = await this.makeGETRequest('/api/resource/fueltax-preferences' + groupId);		
		return data;		
	}

	async saveFuelTaxPref(pref, edit) {
		var saved = await this.makePUTRequest('/api/resource/fueltax-preferences', pref);	
		return saved;		
	}	
	
}
